import { Link } from 'react-router-dom';
import { Container } from 'styles/container.styles';
import { GUIDES } from 'data/guides';
import AdSense from 'components/AdSense';
import { ADSENSE_SLOTS } from 'config/adsense.config';
import { GuideListContainer } from '../styles';

const GuideList = () => {
  return (
    <Container>
      <GuideListContainer>
        <div className='guide-intro'>
          <h1>소상공인 마트·슈퍼 운영 가이드</h1>
          <p>
            마트통포스가 현장 경험을 바탕으로 정리한 매장 운영 콘텐츠입니다. POS
            선택, 재고관리, 키오스크·무인매장, ESL·POP, CRM 마케팅까지 사장님이
            바로 적용할 수 있는 실무 중심으로 안내합니다.
          </p>
          <p>
            광고보다 도움이 되는 정보를 먼저 제공하는 것이 목표입니다. 도입
            상담이 필요하면 가이드를 읽으신 뒤 고객문의로 남겨 주세요.
          </p>
        </div>

        <div className='guide-list'>
          {GUIDES.map((guide) => (
            <Link
              key={guide.slug}
              to={`/guide/${guide.slug}`}
              className='guide-card'
            >
              <div className='guide-card__meta'>
                <span className='guide-card__category'>{guide.category}</span>
                <span>{guide.publishedAt}</span>
                <span>약 {guide.readingMinutes}분</span>
              </div>
              <p className='guide-card__title'>{guide.title}</p>
              <p className='guide-card__desc'>{guide.description}</p>
            </Link>
          ))}
        </div>

        <AdSense slot={ADSENSE_SLOTS.inArticle} />
      </GuideListContainer>
    </Container>
  );
};

export default GuideList;
